import dayjs from "dayjs";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MedicalService from "../Services/MedicalService";
import { HSdecrypt } from "../utils/encryptPassword";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import profile from "../assets/images/ProfileImage.jpg";
import ChronicConditionService from "../Services/ChronicConditionService";
import { QRCodeCanvas } from "qrcode.react";
import { convertUTCDate } from "../utils/convertionFunc";
import { Flex, Spin } from "antd";
import PatientService from "../Services/PatientService";
import { AiOutlineIdcard } from "react-icons/ai";
import EmcIcon from "../assets/images/Emcicon.png";
import Cardbg from "../assets/images/Cardbg.png";
import CardLogo from "../assets/images/Cardlogo.png";

const EmergencyDataView = forwardRef(function EmergencyDataView(_, ref) {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [isLoading, setIsLoading] = useState({
    allergy: false,
    chronics: false,
    drug: false,
  });
  const [medications, setMedications] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    PatientAllergies();
    PatientchronicConditions();
    patientMedication();
    getPatientDetails();
    PatientEmergencyData();
  }, []);

  const getPatientDetails = async () => {
    const payload = { patientId: loggedUser.patientId };
    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const PatientAllergies = () => {
    setIsLoading((prev) => ({ ...prev, allergy: true }));
    MedicalService.HSPatientAllergyList({
      patientCode: loggedUser.patientId,
      status: 1,
    })
      .then((result) => {
        const parsed = JSON.parse(HSdecrypt(result.data.data));
        setPatientAlleryData(
          parsed?.map((item) => ({ drugAllergy: item["drugAllergy"] })),
        );
        setIsLoading((prev) => ({ ...prev, allergy: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, allergy: false })));
  };

  const PatientchronicConditions = () => {
    setIsLoading((prev) => ({ ...prev, chronics: true }));
    ChronicConditionService.HSPatientchronicConditions({
      patientId: loggedUser.patientId,
    })
      .then((result) => {
        setChronicConditions(JSON.parse(HSdecrypt(result.data.data)));
        setIsLoading((prev) => ({ ...prev, chronics: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, chronics: false })));
  };

  const patientMedication = () => {
    setIsLoading((prev) => ({ ...prev, drug: true }));
    MedicalService.HSPatientMedication({
      patientCode: loggedUser.patientId,
      status: 1,
    })
      .then((result) => {
        setMedications(JSON.parse(HSdecrypt(result.data.data)));
        setIsLoading((prev) => ({ ...prev, drug: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, drug: false })));
  };

  const handleDownload = useCallback(async () => {
    const frontSide = frontRef.current;
    const backSide = backRef.current;
    if (!frontSide || !backSide) return;

    const originalFrontDisplay = frontSide.style.display;
    const originalBackDisplay = backSide.style.display;
    const originalBackTransform = backSide.style.transform;
    const originalBackfaceVisibility = backSide.style.backfaceVisibility;

    try {
      await document.fonts?.ready;
      backSide.style.display = "none";
      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";
      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
        backgroundColor: "#002B42",
      });
      const backImage = backCanvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;
      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight,
      );
      pdf.save("Emergency_MedicalCard.pdf");
    } catch (error) {
      console.error("Unable to download emergency medical card", error);
    } finally {
      frontSide.style.display = originalFrontDisplay;
      backSide.style.display = originalBackDisplay;
      backSide.style.transform = originalBackTransform;
      backSide.style.backfaceVisibility = originalBackfaceVisibility;
    }
  }, []);

  useImperativeHandle(ref, () => ({ download: handleDownload }), [
    handleDownload,
  ]);

  const calculateAge = (dob) => {
    const dobYear = dob?.split("/")[2];
    return dobYear ? new Date().getFullYear() - Number(dobYear) : "";
  };

  const PatientEmergencyData = () => {
    let patientDataV = JSON.parse(
      localStorage.getItem("patientData") || "null",
    );
    // MedicalService.PatientQrList({
    //   status: 1,
    //   patientId: patientDataV?.patientId,
    // }).then((result) => {
    //   if (result?.data[0]?.healthCardUrl) {
    //     setPatientQrData(
    //       "https://doctor-dev.doxzon.com/emergencyqr/" +
    //         result.data[0].healthCardUrl,
    //     );
    //   }
    // });
    setPatientQrData(
      `${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${loggedUser.patientId}`,
    );
  };

  const handleCardClick = () => setIsFlipped((prev) => !prev);

  const isAnyLoading =
    isLoading.allergy || isLoading.chronics || isLoading.drug || !patDetails;

  return (
    <>
      <div className="w-full">
        {isAnyLoading ? (
          <div className="flex min-h-[250px] items-center justify-center">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          <>
            <div
              className="relative h-[250px] w-full cursor-pointer [perspective:1000px]"
              onClick={handleCardClick}
            >
              <div
                className={`relative h-full w-full [transform-style:preserve-3d] transition-transform duration-700 ${isFlipped ? "[transform:rotateY(180deg)]" : ""}`}
              >
                <div
                  className="absolute w-full rounded-lg border-2 border-slate-200 bg-white [backface-visibility:hidden]"
                  ref={frontRef}
                >
                  <div
                    className="flex h-12 items-center justify-between rounded-t-md px-2"
                    style={{
                      backgroundImage: `url(${Cardbg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <span className="text-sm font-medium text-white">
                      Emergency Medical Card
                    </span>
                    <div className="flex items-center gap-2">
                      <img src={CardLogo} alt="Doxzon" />
                    </div>
                  </div>

                  <div className="flex w-full justify-evenly p-2">
                    <div className="flex w-[75%] items-center gap-5">
                      <div className="flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl border bg-white">
                        <img
                          src={
                            patDetails?.photoNameBase64
                              ? "data:image/jpeg;base64," +
                                patDetails.photoNameBase64
                              : profile
                          }
                          alt="Patient"
                          className="h-full w-full object-cover"
                        />
                      </div>
                      <div className="min-w-0 font-inter">
                        <h4 className="mt-2 text-sm font-normal text-[#5C5C5C]">
                          Name:{" "}
                          <span className="font-bold text-[#197EBC]">
                            {[
                              patDetails?.salutation,
                              patDetails?.firstName,
                              patDetails?.lastName,
                            ]
                              .filter(Boolean)
                              .join(" ")}
                          </span>
                        </h4>
                        <h4 className="mt-2 text-sm font-normal text-[#5C5C5C]">
                          Age:{" "}
                          <span className="font-bold text-[#333333]">
                            {calculateAge(patDetails?.ageDob)}
                          </span>
                        </h4>
                        <h4 className="mt-2 text-sm font-normal text-[#5C5C5C]">
                          BloodGroup:{" "}
                          <span className="font-bold text-[#333333]">
                            {patDetails?.bloodGroup || "N/A"}
                          </span>
                        </h4>
                        <h4 className="mt-2 text-sm font-normal text-[#5C5C5C]">
                          Mobile No:{" "}
                          <span className="font-bold text-[#333333]">
                            {patDetails?.mobile || "N/A"}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div className="flex w-[25%] justify-end">
                      <div className="mt-3 flex h-24 w-24 items-center justify-center rounded-lg border bg-white">
                        {patientQrData && (
                          <QRCodeCanvas value={patientQrData} size={80} />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 flex h-10 items-center justify-center gap-3 rounded-lg bg-[#002B42] px-3">
                    <div className="h-6 w-24 shrink-0 rounded-md bg-[#EF5050] text-center">
                      <span
                        className="block h-full whitespace-nowrap text-xs font-medium text-white"
                        style={{ lineHeight: "24px" }}
                      >
                        Emergency
                      </span>
                    </div>
                    <h6 className="m-0 whitespace-nowrap text-xs font-medium leading-none text-white">
                      Mobile Number:{" "}
                      <span className="text-sm font-semibold">
                        {patDetails?.emergencyContact || "N/A"}
                      </span>
                    </h6>
                  </div>
                </div>

                <div
                  className="absolute h-full w-full overflow-hidden rounded-lg border-2 border-slate-200 bg-[#002B42] [backface-visibility:hidden] [transform:rotateY(180deg)]"
                  ref={backRef}
                >
                  <div className="flex h-full flex-col justify-between rounded-md bg-[#002B42] shadow">
                    <div className="flex flex-1 flex-col items-center justify-center px-4 py-6 text-center">
                      <span className="mt-10 text-sm font-semibold text-white">
                        Access my personal Health Records At:
                      </span>
                      <a
                        href={`${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patDetails?.patientId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(event) => event.stopPropagation()}
                        className="mt-1 text-sm font-bold text-[#189FAA] underline transition hover:text-[#117a80]"
                      >
                        {`${process.env.REACT_APP_FRONTEND_URL?.replace(/^https?:\/\//, "")}/PHR-ACCESS`}
                      </a>
                    </div>
                    <div className="flex h-10 items-center justify-center gap-3 rounded-b-md border-t border-gray-200 bg-gray-50 px-3">
                      <span
                        className="block h-7 w-24 shrink-0 rounded-md bg-[#0AA0AC] text-center text-sm font-semibold text-white"
                        style={{ lineHeight: "28px" }}
                      >
                        Member ID
                      </span>
                      <div className="flex items-center gap-2 whitespace-nowrap text-sm leading-none">
                        <AiOutlineIdcard className="h-5 w-5" />
                        <span className="m-0">ID No:</span>
                        <span className="text-sm font-semibold">
                          {patDetails?.patientId}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span className="mt-2 text-center text-xs text-slate-400">
              Tap card to flip
            </span>
          </>
        )}
      </div>
    </>
  );
});

export default EmergencyDataView;
